import React from 'react';
import PropTypes from 'prop-types';
import { TABLE_ID } from '@modules/transactions/constants/TableId';
import { LOADING_IDS } from '@common/constants/fetch/loading.ids';
import { trans } from '../../modules/translation/translate';
import { enhanceComponent } from '../../wrappers/enhanceComponent';
import { TransactionsTablesTabsContainer } from '../../components/transactionsTablesTabs/transactionsTablesTabs.container';
import { StyledMainDashboardV2 } from '../../modules/style/components/MainDashboard.styled';

class AllTransactionsPage extends React.PureComponent {
	static propTypes = {
		deviceType: PropTypes.string,
	};

	constructor(props) {
		super(props);
		this.state = {
			tables: [
				{
					id: TABLE_ID.myBets,
					name: 'my bets',
					loadingId: LOADING_IDS.GET_USER_BETS,
				},
				{
					id: TABLE_ID.sessions,
					name: 'Auto Sessions',
					loadingId: 'getSessions',
				},
				{
					id: TABLE_ID.depositHistory,
					name: 'Deposits',
					loadingId: 'getDepositHistory',
				},
				{
					id: TABLE_ID.withdrawHistory,
					name: 'Withdraws',
					loadingId: 'getWithdrawHistory',
				},
				{
					id: TABLE_ID.otherTransactions,
					name: 'Others',
					loadingId: 'getOtherTransactions',
				},
			],
		};
	}

	render() {
		return (
			<StyledMainDashboardV2>
				<h1 className="page-title">{trans({ label: 'Transactions' })}</h1>
				<TransactionsTablesTabsContainer tables={this.state.tables} />
			</StyledMainDashboardV2>
		);
	}
}

AllTransactionsPage = enhanceComponent({
	AllTransactionsPage,
});

export default AllTransactionsPage;
